(function (root) {
  'use strict';
  // Mirrors the Parcelify Universal Shipping rules exported to icraft-delivery-rules.json:
  // zone chosen by state; every matching price in the zone's rate is added; per-item prices x chair quantity.
  const normalize = value => String(value ?? '').trim();
  const STATES = ['NSW','ACT','VIC','QLD','SA','WA','TAS','NT'];
  // Lenient Australia Post first-digit families: only reject clear state/postcode mismatches.
  function stateAllowed(postcode, state) {
    const d = postcode[0], n = Number(postcode);
    if (d === '0') return n >= 800 ? state === 'NT' : (state === 'ACT' || state === 'NSW');
    if (d === '1' || d === '2') return state === 'NSW' || state === 'ACT';
    if (d === '3' || d === '8') return state === 'VIC';
    if (d === '4' || d === '9') return state === 'QLD';
    if (d === '5') return state === 'SA';
    if (d === '6') return state === 'WA';
    if (d === '7') return state === 'TAS';
    return false;
  }
  function classify(rules, address) {
    const postcode = normalize(address.postcode), state = normalize(address.state).toUpperCase();
    if (address.country && address.country !== 'AU') return {status:'unsupported_country'};
    if (!/^\d{4}$/.test(postcode)) return {status:'invalid_postcode'};
    if (!STATES.includes(state) || !stateAllowed(postcode, state)) return {status:'state_mismatch'};
    const zone = rules.zones.find(z => z.states.includes(state));
    if (!zone) return {status:'no_rates'};
    return {status:'matched', zone, postcode, state};
  }
  function quote(rules, address, lines) {
    const place = classify(rules, address);
    if (place.status !== 'matched') return place;
    if (!Array.isArray(lines) || !lines.length) return {status:'empty_cart'};
    let quantity = 0;
    for (const line of lines) {
      if (!Number.isSafeInteger(line.quantity) || line.quantity < 1) return {status:'invalid_quantity'};
      if (!line.requiresShipping) continue;
      if (!rules.productTypes.includes(normalize(line.productType))) return {status:'mixed_cart'};
      quantity += line.quantity;
    }
    if (!quantity) return {status:'no_chairs'};
    let unitCents = 0, flatCents = 0;
    for (const price of place.zone.prices) {
      const hit = !price.prefixes || price.prefixes.some(p => place.postcode.startsWith(p));
      if (!hit) continue;
      if (price.perItem) unitCents += price.cents; else flatCents += price.cents;
    }
    const amountCents = unitCents * quantity + flatCents;
    if (!Number.isSafeInteger(amountCents)) return {status:'invalid_quantity'};
    if (amountCents > rules.maxTotalCents) return {status:'large_order', quantity};
    return {status:'estimate', quantity, unitCents, flatCents, amountCents, zone:place.zone.name, version:rules.version};
  }
  const api = {classify, quote, stateAllowed};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ICraftPostcodeEngine = api;
})(typeof window !== 'undefined' ? window : this);
